import React, { useEffect, useState } from 'react'
import 'common/css/master.css';



function QuestionPaperPatternTbl(props) {
    const { lstPattern, patternId, setPatternId, editPattern } = props;

    const [lstPatternFiltered, setLstPatternFiltered] = useState([]);
    const [selPatternId, setSelPatternId] = useState(0);

    useEffect(() => {
        // console.log("QuestionPaperPatternTbl called lstPattern", lstPattern);
        setLstPatternFiltered(lstPattern);
    }, [lstPattern]);

    useEffect(() => {
        // console.log("QuestionPaperPatternTbl called patternId", patternId);
        setSelPatternId(patternId);
    }, [patternId]);


    const colgrp = <colgroup>
        <col width="60"></col>
        <col width="30"></col>
        <col width="30"></col>
        <col width="30"></col>
        <col width="40"></col>
        <col width="40"></col>
        <col width="50"></col>
    </colgroup>

    return (
        <div >
            <div className="col-md-12 col-xs-12 col-sm-12 col-centered padding-remove" >
                <table className='tableLayout1'>
                    {colgrp}
                    <thead>
                        <tr>
                            <th className='padding-remove'>
                                Pattern
                            </th>
                            <th className='padding-remove'>
                                Max Marks
                            </th>
                            <th className='text-center'>No of Sections</th>
                            <th className='text-center'>Total Questions</th>
                            <th className='text-center'>Approved On</th>
                            <th className='text-center'>Approved By</th>
                            <th className='text-center'>Action</th>
                        </tr>
                    </thead>
                </table>
                <div className="tableDiv" style={{ height: "50vh" }}>
                    <table className="tableLayout">
                        {colgrp}
                        <tbody id="diaryMonthlyTeacherAllocationTable" >
                            {lstPatternFiltered &&
                                lstPatternFiltered.map((pattern, i) => (
                                    <tr key={pattern.patternId}
                                        onClick={() => setPatternId(pattern.patternId)}
                                        className={pattern.patternId === selPatternId ? "selected" : ''}>
                                        <td className="text-left">{pattern.pattern}</td>
                                        <td className="text-center">{pattern.maxMarks}</td>
                                        <td className="text-center">{pattern.noOfSections}</td>
                                        <td className="text-center">{pattern.totalQuestion}</td>
                                        <td className="text-center">{pattern.approvalDttm}</td>
                                        <td className="text-center">{pattern.approvalBy}</td>
                                        <td className="text-center">
                                            <span
                                                onClick={() => editPattern(pattern)}
                                                title="Edit Pattern Details"
                                                style={{ textDecoration: "underline", cursor: "pointer", color: "blue", margin: "5px" }}
                                            >
                                                Edit
                                            </span>
                                            {/* <span
                                                onClick={() => deletePattern(pattern.patternId)}
                                                title="Delete Pattern"
                                                style={{ textDecoration: "underline", cursor: "pointer", color: "blue", margin: "5px" }}
                                            >
                                                Delete
                                            </span> */}
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default QuestionPaperPatternTbl;